"use client"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { mediaQueries, sizes } from "ui"
import { getNonUmbracoUrl } from "utils"
import ActionItem from "./ActionItem"
import { StyledLink } from "./FormsAndActionsComponent/styles"

interface ActionItemListCenterProps {
  data?: any[]
  title?: string
  link?: {
    href: string
    name: string
  }
}

const StyledActionsItemsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${sizes.baseDouble};
  width: 404px;
  padding-inline-end: ${sizes.basePenta};
  ${mediaQueries.tabletDown} {
    width: 100%;
    padding-inline-end: 0;
  }
  ${mediaQueries.desktopM} {
    width: 292px;
  }
  ${mediaQueries.desktop} {
    width: 404px;
  }
`

const ActionItemListCenter = ({
  data,
  title,
  link,
}: ActionItemListCenterProps) => {
  return (
    <StyledActionsItemsContainer>
      {title && <Typography variant="h4">{title}</Typography>}
      {data?.map((item: any, index: number) => (
        <ActionItem
          key={`ActionItemListCenter-${index}`}
          item={item}
          actionItems={[]}
        />
      ))}
      {link && (
        <StyledLink href={getNonUmbracoUrl(link?.href)}>
          {link?.name}
        </StyledLink>
      )}
    </StyledActionsItemsContainer>
  )
}

export default ActionItemListCenter
